export const values = {
  'icon.s': 16,
  'icon.m': 20,
  'icon.ml': 30,
  'icon.l': 36,
  'dateinput.day': 40,
};
